import { injectIntl } from "react-intl";
import type { intlFormatPropTypes } from "react-intl";

import { Item } from "@ps-design-system/components/ItemV2";
import { ItemGroup } from "@ps-design-system/components/ItemGroup";
import ReviewIcon from "@ps-design-system/icons/Review/Review24";

import type { UnreadReviewSpaceCardData } from "../types/model/unread-review";

type HostHubUnreadReviewsGroupProps = {
  cards: UnreadReviewSpaceCardData[];
  intl: intlFormatPropTypes;
  onSpaceClick: (spaceId: string) => void;
};

const HostHubUnreadReviewsGroup = ({
  cards,
  intl,
  onSpaceClick,
}: HostHubUnreadReviewsGroupProps) => {
  if (0 === cards.length) return null;

  const title = intl.formatMessage({
    defaultMessage: "You have unread reviews",
    id: "host_hub.todo_list.unread_reviews_title",
  });
  const description = intl.formatMessage({
    defaultMessage: "See what guests said about their experience",
    id: "host_hub.todo_list.unread_reviews_subtitle",
  });

  // A single unread space renders as a standalone item (no expandable group).
  if (1 === cards.length) {
    return (
      <Item
        buttonOnClick={() => onSpaceClick(cards[0].spaceId)}
        description={description}
        icon={<ReviewIcon />}
        size="lg"
        title={title}
        variant="outline"
      />
    );
  }

  return (
    <ItemGroup defaultExpanded size="lg" variant="outline">
      <Item description={description} icon={<ReviewIcon />} title={title} />
      {cards.map(({ photoUrl, spaceId, title: spaceTitle }) => {
        const mediaProps = photoUrl
          ? { media: photoUrl, mediaAlt: spaceTitle, mediaSize: 56 }
          : { icon: <ReviewIcon /> };

        return (
          <Item
            buttonOnClick={() => onSpaceClick(spaceId)}
            key={spaceId}
            title={spaceTitle ?? ""}
            {...mediaProps}
          />
        );
      })}
    </ItemGroup>
  );
};

export default injectIntl(HostHubUnreadReviewsGroup);
